import { productionTheme, testTheme } from "./theme";


export default {
    apiUrl: 'api',
    theme: (true || process.env.MIX_APP_MODE === 'production') ? productionTheme : testTheme,
    mode: process.env.MIX_APP_MODE || 'production'
};
